import api from '../../../api/parametres/_parametres'
import api_config from '../../../api/config/_user'
import api_examen from '../../../api/_examen'
import api_cpn from '../../../api/_cpn'
import api_access from '../../../api/parametres/_accessibilite'

export default {
    getAttributionAutomatiqueConsultation(id) {
        return api.getAttributionAutomatiqueConsultation(id)
    },
    saveAttributionAutomatiqueConsultation(id, data) {
        return api.saveAttributionAutomatiqueConsultation(id, data)
    },
    getRemunerationPrestations() {
        return api.getRemunerationPrestations()
    },
    getMedecinRemuneration(user_id) {
        return api.getMedecinRemuneration(user_id)
    },
    saveMedecinRemuneration(user_id, data) {
        return api.saveMedecinRemuneration(user_id, data)
    },
    getHistoriqueConfig(data) {
        return new Promise((resolve, reject) => {
            api.getHistoriqueConfig(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAdminUsers() {
        return new Promise((resolve, reject) => {
            api_config.getAdminUsers().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getCouponAuthorizedUsers() {
        return new Promise((resolve, reject) => {
            api_config.getCouponAuthorizedUsers().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeSectionAntecedents() {
        return new Promise((resolve, reject) => {
            api.getListeSectionAntecedents().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveSectionAntecedents(data) {
        return new Promise((resolve, reject) => {
            api.saveSectionAntecedents(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    reorderSectionAntecedents(data) {
        return new Promise((resolve, reject) => {
            api.reorderSectionAntecedents(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deactivateATCDPatient(data) {
        return new Promise((resolve, reject) => {
            api.deactivateATCDPatient(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeTypeExamens() {
        return new Promise((resolve, reject) => {
            api_examen.getExamens().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveModeleExamen(data) {
        return new Promise((resolve, reject) => {
            api.saveModeleExamen(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeModeleExamens(data) {
        return new Promise((resolve, reject) => {
            api.getListeModeleExamens(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeChampByModeleExamen(data) {
        return new Promise((resolve, reject) => {
            api.getListeChampByModeleExamen(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTriUrgence(data) {
        return new Promise((resolve, reject) => {
            api.saveTriUrgence(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTriUrgence() {
        return new Promise((resolve, reject) => {
            api.getTriUrgence().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    reOrderTriUrgence(data) {
        return new Promise((resolve, reject) => {
            api.reOrderTriUrgence(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveCoupureBilletage(data) {
        return new Promise((resolve, reject) => {
            api.saveCoupureBilletage(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getCoupureBilletage(data_type) {
        return new Promise((resolve, reject) => {
            api.getCoupureBilletage(data_type).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateCoupureBilletage(data) {
        return new Promise((resolve, reject) => {
            api.updateCoupureBilletage(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    removeCoupureBilletage(data) {
        return new Promise((resolve, reject) => {
            api.removeCoupureBilletage(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteTriUrgence(data) {
        return new Promise((resolve, reject) => {
            api.deleteTriUrgence(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeAdmissions(data_type) {
        return new Promise((resolve, reject) => {
            api.getListeTypeAdmission(data_type).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAllParamCpn() {
        return new Promise((resolve, reject) => {
            api_cpn.getAllParamCpn().then(
                response => {
                    resolve(response);
                }, error => {

                    reject(error);
                }
            )
        })
    },

    saveParamCpn(data) {
        return new Promise((resolve, reject) => {
            api_cpn.saveParamCpn(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateParamCpn(data) {
        return new Promise((resolve, reject) => {
            api_cpn.updateParamCpn(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteParamCpn(data) {
        return new Promise((resolve, reject) => {
            api_cpn.deleteParamCpn(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteLits(data) {
        return new Promise((resolve, reject) => {
            api.deleteLits(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveLit(data) {
        return new Promise((resolve, reject) => {
            api.saveLit(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeOccurencesByChamp(data) {
        return new Promise((resolve, reject) => {
            api.getListeOccurencesByChamp(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getRolePersonnels() {
        return new Promise((resolve, reject) => {
            api_access.getRolePersonnels().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getPersonnels() {
        return api_access.getPersonnels()
    },

    getResetPwdCode(user_id) {
        return api_access.getResetPwdCode(user_id)
    },

    getListeAccessToPrestation(data) {
        return new Promise((resolve, reject) => {
            api_access.getListeAccessToPrestation(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setResetPwdCode(data) {
        return new Promise((resolve, reject) => {
            api_access.setResetPwdCode(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    changePassword(data) {
        return new Promise((resolve, reject) => {
            api_access.changePassword(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}
